import { WishlistMessageType } from "@redotech/redo-model/conversation/message-parsers/wishlist-message-parser";
import { memo } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
import * as wishlistDisplayCss from "./wishlist-display.module.css";

export interface WishlistDisplayProps {
  message: WishlistMessageType;
}

export const WishlistDisplay = memo(function WishlistDisplay({
  message,
}: WishlistDisplayProps) {
  const items = message.structuredContent?.items ?? [];
  const itemCount = message.structuredContent?.itemCount ?? items.length;

  if (items.length === 0) {
    return (
      <Flex dir="column" gap="sm" p="md">
        <Text fontSize="sm" textColor="secondary">
          Your wishlist is empty
        </Text>
      </Flex>
    );
  }

  return (
    <Flex dir="column" gap="md" w="full">
      <Text fontSize="sm" fontWeight="semibold">
        Your Wishlist ({itemCount} {itemCount === 1 ? "item" : "items"})
      </Text>
      <Flex dir="column" gap="sm" w="full">
        {items.map((item, index) => (
          <Flex
            align="center"
            borderColor="primary"
            borderStyle="solid"
            borderWidth="1px"
            className={wishlistDisplayCss.wishlistItem}
            dir="row"
            gap="md"
            key={`${item.productId}-${item.variantId ?? index}`}
            p="sm"
            radius="md"
          >
            {item.imageUrl && (
              <img
                alt={item.title ?? "Product"}
                className={wishlistDisplayCss.productImage}
                src={item.imageUrl}
              />
            )}
            <Flex dir="column" flex={1} gap="xs">
              <Text fontSize="sm" fontWeight="semibold">
                {item.title ?? "Product"}
              </Text>
              {item.price && (
                <Text fontSize="xs" textColor="secondary">
                  {item.price}
                </Text>
              )}
            </Flex>
            {item.url && (
              <a
                className={wishlistDisplayCss.viewLink}
                href={item.url}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Text fontSize="xs" textColor="primary">
                  View
                </Text>
              </a>
            )}
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
});
